import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Skeleton,
} from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledTableContainer = styled(TableContainer)(() => ({
    height: '100%',
    overflow: 'auto',
    marginBottom: '24px',
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    padding: theme.spacing(4),
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
}));

const COLUMN_WIDTHS = {
    strategyName: '100%',
};

const COLUMN_HEADERS = {
    strategyName: 'Strategy Name',
};

export const ForcedRankingSearchResultsSkeleton = (): JSX.Element => {
    const skeletonRows = Array.from({ length: 5 }, (_, i) => i);

    return (
        <StyledTableContainer>
            <Table stickyHeader>
                <TableHead>
                    <TableRow>
                        <StyledTableCell align="left" width={COLUMN_WIDTHS.strategyName}>{COLUMN_HEADERS.strategyName}</StyledTableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {skeletonRows.map((index) => (
                        <TableRow key={`skeleton-${index}`}>
                            <StyledTableCell align="left" width={COLUMN_WIDTHS.strategyName}><Skeleton animation="wave" /></StyledTableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </StyledTableContainer>
    );
};
